// combatpro/panels/monsters/studio/MonsterStudioTabs.js
//
// Combat PRO - MonsterStudioTabs (Stage 54: Monster Studio Foundation).
//
// The .vi-st-tabs editor tab navigation. The tab registry is derived 1:1 from
// VI_STUDIO_TABS (battletracker.html 10847-10851) - [id, label] pairs, order and
// label text verbatim - mirroring the existing viewRegistry convention of holding
// static nav metadata as data. The legacy viStudioRenderTabsNav rendered these
// same buttons and toggled is-active on the active tab.
//
// Presentational shell only. The active tab is cosmetic UI state owned by the
// parent workspace (passed via activeTab / onSelectTab); selecting a tab only
// moves the highlight. The per-tab editor content (#vi-st-tabpanel) is NOT
// rendered here and is deferred to a later stage. This component owns no monster
// data and touches no runtime, persistence, or context. No optional chaining.

import React from 'react';

// [id, label], verbatim from VI_STUDIO_TABS.
var MONSTER_STUDIO_TABS = [
  ['identity', 'IDENTITY'], ['core', 'CORE STATS'], ['defences', 'DEFENCES'], ['movement', 'MOVEMENT'],
  ['traits', 'TRAITS'], ['actions', 'ACTIONS'], ['bonus', 'BONUS ACTIONS'], ['reactions', 'REACTIONS'],
  ['legendary', 'LEGENDARY ACTIONS'], ['lair', 'LAIR ACTIONS'], ['spellcasting', 'SPELLCASTING'],
  ['behaviour', 'BEHAVIOUR'], ['conditions', 'CONDITIONS'], ['notes', 'NOTES']
];

function MonsterStudioTabs(props) {
  var active = props.activeTab || 'identity';
  return (
    <div className="vi-st-tabs" id="vi-st-tabs">
      {MONSTER_STUDIO_TABS.map(function(t) {
        var id = t[0];
        var label = t[1];
        var cls = 'vi-st-tab' + (id === active ? ' is-active' : '');
        return (
          <button
            key={id}
            type="button"
            className={cls}
            onClick={function() { if (props.onSelectTab) { props.onSelectTab(id); } }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default MonsterStudioTabs;
